<template>
  <!--geurs-area-start-->
  <div class="geues-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="geurs-containt">
            <div class="main-title">
              <h3>
                {{ article.title }}
              </h3>
              <p>
                {{ article.subTitle }}
              </p>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-6">
                <div class="">
                  <p v-html="article.text"></p>
                </div>
                <div class="hero-btn" v-if="buttonLink">
              <a :href="buttonLink" class="theme-btn"
                >{{buttonText}}</a>
            </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-first order-lg-last" v-if="article.images">
          <div class="gures-img">
            <img :src="article.images.url" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--geurs-area-end-->
</template>

<script>
import { getArticle } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  created() {
    getArticle(this.slug).then(res => {
      this.article = translate(res[0]);
    });
  },
  props: {
    slug: {
      type: String
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      article: {}
    };
  }
};
</script>

<style lang="scss" scoped></style>
